import {loadDynamicStyles} from "./indexStyles";

loadDynamicStyles(() =>
  require('./AppRenderer'));
